import Editor from "@monaco-editor/react";
import React from "react";

const MonacoEditorWrapper = ({ value, onChange }: { value?: string; onChange?: (value: string | undefined) => void }) => {
    return (
        <div style={{
            border: '1px solid #d9d9d9',
            borderRadius: '2px',
            backgroundColor: '#fafafa',
            overflow: 'hidden'
        }}>
            <Editor
                height="400px"
                defaultLanguage="plaintext"
                theme="vs-light"
                value={value}
                onChange={onChange}
                options={{
                    minimap: { enabled: false },
                    fontSize: 14,
                    wordWrap: 'on',
                    lineNumbers: 'off',
                    trimAutoWhitespace: false,
                }}
            />
        </div>
    );
};

export default MonacoEditorWrapper;